<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import BookingCommentsForm from '~src/components/booking/forms/bookingCommentsForm.src'

    @Component({mixins: [BookingCommentsForm]})
    export class TransferReturnBookingCommentsForm extends Vue {
        get comment() {
            return transfersStore.prepareBookReturnTransferRequest.comments
        }

        set comment(val) {
            transfersStore.SET_PREPARE_BOOK_RETURN_TRANSFER_REQUEST_PROP({prop: 'comments', val})
        }
    }

    export default {...toNative(TransferReturnBookingCommentsForm), ssrRender: BookingCommentsForm.ssrRender}
</script>
